import React from 'react'

import {
  availableLanguages,
  availableLanguagesWopi360
} from './../assets/translations/availableLanguages'

import styles from './styles/app.scss'

import { DropdownButton, MenuItem } from 'react-bootstrap'

class LanguageSwitcher extends React.Component {
  render() {
    const { hideNonAdminLanguages, currentLanguage, isWopi360LanguagesUsed = false } = this.props

    const resolveLanguages = () => {
      const languages = isWopi360LanguagesUsed ? availableLanguagesWopi360 : availableLanguages

      return hideNonAdminLanguages ? languages.filter(l => l.availableInAdmin) : languages
    }

    const languages = resolveLanguages()

    return (
      <DropdownButton
        id="language-switcher"
        pullRight
        className={styles.languageSwitcher}
        title={currentLanguage ? currentLanguage : ''}
      >
        {languages.map((language, key) => (
          <MenuItem
            eventKey={key}
            key={key}
            onClick={this.onChangeLanguage(language.key).bind(this)}
          >
            {language.name}
          </MenuItem>
        ))}
      </DropdownButton>
    )
  }

  onChangeLanguage(language) {
    return () => {
      this.props.onChangeLanguage(language)
    }
  }
}

export default LanguageSwitcher



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.js